import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: isScrolled ? 'rgba(15, 23, 42, 0.95)' : 'transparent',
        backdropFilter: isScrolled ? 'blur(10px)' : 'none',
        transition: 'all 0.3s ease',
        boxShadow: isScrolled ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
      }}
    >
      <div style={{
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '1rem 1.5rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}
          aria-label="NOMOISTURE - Container Desiccants & Moisture Protection Home"
          style={{ cursor: 'pointer', textDecoration: 'none', display: 'inline-block' }}
        >
          <span 
          style={{
          fontSize: '1.75rem',
          fontFamily: '"Zalando Sans Expanded", sans-serif',
          fontWeight: 900,
          color: '#ECEC75',
          fontOpticalSizing: 'auto',
          }}
          >
          NO
          </span>
          <span 
          style={{
          fontSize: '1.75rem',
          fontFamily: '"Zalando Sans Expanded", sans-serif',
          fontWeight: 450,
          color: '#ECEC75',
          }}
          >
          MOISTURE
          </span>
        </a>


        {/* Desktop Navigation */}
        <nav aria-label="Primary" style={{ display: 'none' }} className="desktop-nav">
          {['home', 'about', 'products', 'faq', 'contact'].map((item) => (
            <button
              key={item}
              onClick={() => scrollToSection(item)}
              style={{
                background: 'none',
                border: 'none',
                color: '#cbd5e1',
                fontSize: '1rem',
                fontWeight: 600,
                cursor: 'pointer',
                padding: '0.5rem 1rem',
                transition: 'all 0.2s ease',
                textTransform: 'capitalize',
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#ECEC75';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#cbd5e1';
              }}
            >
              {item}
            </button>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label={isMobileMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMobileMenuOpen}
          aria-controls="mobile-nav"
          style={{
            display: 'block',
            background: 'none',
            border: 'none',
            color: '#ECEC75',
            cursor: 'pointer',
            padding: '0.5rem',
          }}
          className="mobile-menu-btn"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <nav id="mobile-nav" aria-label="Mobile" style={{
          background: 'rgba(15, 23, 42, 0.98)',
          padding: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}>
          {['home', 'about', 'products', 'faq', 'contact'].map((item) => (
            <button
              key={item}
              onClick={() => scrollToSection(item)}
              style={{
                background: 'none',
                border: 'none',
                color: '#ECEC75',
                fontSize: '1.125rem',
                fontWeight: 600,
                cursor: 'pointer',
                padding: '0.75rem',
                textAlign: 'left',
                textTransform: 'capitalize',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#ffffff';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#ECEC75';
              }}
            >
              {item}
            </button>
          ))}
        </nav>
      )}

      <style>{`
        @media (min-width: 768px) {
          .desktop-nav {
            display: flex !important;
            gap: 0.5rem;
          }
          .mobile-menu-btn {
            display: none !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
